import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PaymentRequest, PaymentTxnDetails, PayorInfo } from 'src/app/models/payment.model';
import { Router } from '@angular/router';
import { PaymentMethodModel } from 'src/app/models/payment-method.model';
import { UserDetails } from 'src/app/models/user-details.model';
import { LoaderService } from 'src/app/services/loader.service';
import { PaymentService } from 'src/app/services/payment.service';
import { StorageService } from 'src/app/services/storage.service';
import { AppConfigService } from 'src/app/config/appconfig.service';

@Component({
  selector: 'app-review-payment-details',
  templateUrl: './review-payment-details.component.html',
  styleUrls: ['./review-payment-details.component.scss']
})
export class ReviewPaymentDetailsComponent {
  payment: PaymentMethodModel;
  userInfo: UserDetails;
  myform: FormGroup;
  submitted = false;
  currentDate: Date;
  paymentAmount: number;

  isPendingPolicy: boolean;
  paymentMethod: any;
  showErrorMessage: boolean =false;
  isGracePayment = false;

  constructor(private router:Router, private fb:FormBuilder, private storageService:StorageService, 
      private loaderService: LoaderService, private paymentService: PaymentService, private config: AppConfigService){
        
    this.currentDate= new Date();
    this.myform = this.fb.group({
      generalTerms:[false, [Validators.requiredTrue]],
      paymentTerms:[true, [Validators.requiredTrue]],
    });
    this.isGracePayment = this.config.getIsGracePayment();
    let isPendingPolicy = this.storageService.getIsPendingPolicy();
    
    if(!this.isGracePayment && isPendingPolicy == null){
      this.router.navigateByUrl('/home');
    } else{
      this.isPendingPolicy = isPendingPolicy ?? false;
    }

    let userInfo = this.storageService.getUserInfo();
    if(userInfo == null){
       this.router.navigateByUrl('/policy-search');
    } else{
      this.userInfo = userInfo;
    }

    let paymentAmount = this.storageService.getPaymentAmount();
    if(paymentAmount == null){
       this.router.navigateByUrl('/payment');
    } else{
      this.paymentAmount = paymentAmount;
    }

    let paymentMethodData = this.storageService.getSelectedPaymentMethod();
    if(paymentMethodData == null){
       this.router.navigateByUrl('/payment-method');
    } else{
      let paymentMethod = paymentMethodData.paymentMethod;
      this.paymentMethod = paymentMethod;
      let bankDetails, creditCard = null;
      this.payment={
        paymentMethod,
        creditCard,
        bankDetails
      }
      if(paymentMethod =='Bank Account'){
        this.payment.bankDetails=paymentMethodData.paymentToken.paymentTxnDetails.electronicFunds.electronicFundsTransfer;
      } else if(paymentMethod =='Credit Card'){
        this.payment.creditCard = paymentMethodData.additionalDetails.additionalCardInfo;
        this.payment.creditCard.profileId = paymentMethodData.paymentToken.paymentTxnDetails.paymentMethod.ProfileId
      } 
    }
  }

  onSubmit() {
    this.submitted=true;
    this.showErrorMessage=false;
    if (this.myform.valid) {
      this.loaderService.showLoader();
      let paymentTxn:PaymentTxnDetails;
      let payorInfo :PayorInfo = undefined;
      if(this.paymentMethod =='Bank Account'){
       
        paymentTxn = {
          paymentMethod: "electronicFunds",
          electronicFunds:{
            electronicFundsTransfer:{
              validateEFT:true,
              bankName:this.payment.bankDetails?.bankName,
              bankAccountNumber:this.payment.bankDetails?.bankAccountNumber,
              bankRoutingNumber:this.payment.bankDetails?.bankRoutingNumber,
              bankAccountType:this.payment.bankDetails?.bankAccountType
            }
          }
        }
        if(this.payment.bankDetails.nameOnAccount){
          payorInfo = {
            entityName: this.payment.bankDetails.nameOnAccount
          }
        } else{
          payorInfo = {
            firstName:this.payment.bankDetails.firstName,
            lastName:this.payment.bankDetails.lastName
          }
        }
      } else if(this.paymentMethod =='Credit Card'){
        let expDate = this.payment.creditCard?.expiryDate;
        let formattedExpDate = expDate.slice(0,4)+"-"+expDate.slice(4);
         paymentTxn = {
          paymentMethod: "bankCard",
          bankCard:{
            bankCardDetails:{
              encryptedPan: this.payment.creditCard?.profileId,
              expirationDate: formattedExpDate,
              ccLastFour: Number(this.payment.creditCard?.cardNumberLastFour),
              cardBrand: this.payment.creditCard?.cardType,
            }
          }
        }
      } 

      let partialPayment:boolean = this.paymentAmount < this.userInfo.balance;

      let request : PaymentRequest = {
        mode: this.isGracePayment ? "grace" : (this.isPendingPolicy ? "default" : "initial"),
        amount: this.paymentAmount,
        paymentTxnDetails:paymentTxn,
        payerInfo: payorInfo,
        partialBill: partialPayment
      }

      this.paymentService.submitPaymentDetails(request).subscribe({
        next: (response: any) => {
          this.storageService.setReceiptId(response.receiptId);
          this.router.navigateByUrl('/confirmation');
        },
        error: (error) => {
          this.showErrorMessage=true;
          this.loaderService.hideLoader();
          window.scrollTo(0, 0);
        }
      })
    } else {
      this.myform.markAllAsTouched();
      window.scrollTo(0,0);
    }

  }

  onBack() {
    this.router.navigateByUrl('/payment-method');
  }

  onCancel() {

    if (this.isGracePayment) {
      this.router.navigate(['/policy-search'], { fragment: 'grace-payment' });
    } else {    
      window.location.href = 'https://www.nationwide.com/personal/member-services/pay-bill?utm_campaign=pl-sitelink&utm_medium=Search&utm_source=Bing&utm_content=All:PL:REP:NA:NA&utm_term=www%20nation&&msclkid=74591eadb69016dcc7837bfa31491e5d&gclid=74591eadb69016dcc7837bfa31491e5d&gclsrc=3p.ds';
    }
  }

}
